import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../pages/login/authentication.service';
import { Router } from '@angular/router';

import { ShowmenuService } from '../showmenu.service';
import { MenucontentService } from '../menucontent.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css'],
})
export class MenuComponent implements OnInit {
  showmenu = false;
  has_individual_start = false;
  checkpoint_array: any;
  mass_start_array: any;
  //events_json: string;

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private ShowmenuService: ShowmenuService,
    private MenucontentService: MenucontentService
  ) {}

  logout() {
    this.authenticationService.logout();
    this.router.navigate(['/login']);
  }
  
  usermanual() {
    window.open("../manual/#item-5-2", "_blank");
  }

  ngOnInit(): void {
    this.ShowmenuService.currentshowMenu.subscribe(
      (showmenu) => (this.showmenu = showmenu)
    );

    this.MenucontentService.currentmenuMassStart.subscribe(
      (mass_start_array) => (this.mass_start_array = mass_start_array)
    );

    this.MenucontentService.currentmenuIndividualStart.subscribe(
      (has_individual_start) => (this.has_individual_start = has_individual_start)
    );

    this.MenucontentService.currentmenuCheckpoints.subscribe(
      (checkpoint_array) => (this.checkpoint_array = checkpoint_array)
    );


    //this.menu_get_mass_starts();
    //this.menu_get_individual_starts();
    //this.menu_get_checkpoints();

    //this.MenucontentService.changeMenuMassStart(this.menu_get_mass_starts());
    //this.MenucontentService.changeMenuMassStart();
 
  }

  menu_participant() {
    localStorage.setItem('global_stage_type', 'Particpant');

    if (localStorage.getItem('global_input_method') == 'scan') {
      this.router.navigateByUrl('/participantscan');
    } else {
      this.router.navigateByUrl('/participantkeyboard');
    }
  }

  // When any of the MASS START buttons are clicked, decide where to go
  menu_mass_start(key, name) {
    localStorage.setItem('global_stage_type', 'Mass Start');

    localStorage.setItem('current_mass_start_id', key);
    localStorage.setItem('current_mass_start_name', name);

    // Check if the race was already started
    var mass_start_id = localStorage.getItem('current_mass_start_id');
    var start_json_array = [];
    start_json_array = JSON.parse(localStorage.getItem('global_start_json'));

    // Route depending on if race was started or not
    if (start_json_array && mass_start_id in start_json_array) {
      this.router.navigate(['/mass-start-done/' + mass_start_id + '/' + name]);
    } else {
      this.router.navigate(['/mass-start/' + name]);
    }
  }

  // When any of the TIMING POINT buttons are clicked, decide where to go
  menu_timing_point(stage_type) {
    localStorage.setItem('global_stage_type', stage_type);

    if (localStorage.getItem('global_input_method') == 'scan') {
      this.router.navigate(['/scan/' + stage_type]);
    } else {
      this.router.navigate(['/type/' + stage_type]);
    }
  }
    



}
